'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

export default ['$scope', '$uibModalInstance', 'ownershipForm', 'OwnershipFormService', 'ModalService', '$security', 'StatusService',
    function($scope, $modalInstance, ownershipForm, OwnershipFormService, ModalService, $security, StatusService) {
        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.editing = editing;
        $scope.isShowEdit = isShowEdit;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.edit = false;
            $scope.uniqueName = true;
            // копирование
            $scope.ownershipForm = angular.copy(ownershipForm);

            // Определение заголовка модального окна
            if (ownershipForm == null || ownershipForm.id == null) {
                $scope.title = 'Создание новой формы владения землей';
                $scope.edit = true;
            } else {
                $scope.title = `Редактирование формы владения землей "${ownershipForm.name}"`;
                $scope.edit = true;
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.ownershipForm.status) {
                    $scope.ownershipForm.status = data._embedded;
                }
            });
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != '') {
                OwnershipFormService.api.exists({
                    filters: (($scope) => {
                        let filters = [];
                        filters.push(`'name' EQ '${scope.ownershipForm.name}'`);
                        if ($scope.ownershipForm.id) {
                            filters.push(`'id' NE '${scope.ownershipForm.id}'`);
                        }
                        return filters;
                    })($scope),
                }, (data) => {
                    $scope.uniqueName = !data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        /**
         * Success
         */
        function ok() {
            $modalInstance.close($scope.ownershipForm);
        }

        /**
         * Dismiss
         */
        function cancel() {
            $modalInstance.dismiss();
        }

        /**
         * Редактировать
         */
        function editing() {
            $scope.edit = true;
        }

        /**
         * Отображать кнопку редактировать?
         * @returns {boolean|*}
         */
        function isShowEdit() {
            return !$scope.edit && $security.isAllowWrite('/src-categories');
        }

        // endregion
    }];
